export default "__VITE_ASSET__D9bwxYW9__"